import script from "./EmployerSignature.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployerSignature.vue?vue&type=script&setup=true&lang=js"

import "./EmployerSignature.vue?vue&type=style&index=0&id=1784076f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1784076f"]])

export default __exports__